<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text-A"><a href="#/Book1/1cover">A Pint of Murder</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/5start#chap1">Chapter 1</a></p>
<p class="toc1"><a href="#/Book1/6chap2#chap2">Chapter 2</a></p>
<p class="toc1"><a href="#/Book1/7chap3#chap3">Chapter 3</a></p>
<p class="toc1"><a href="#/Book1/8chap4#chap4">Chapter 4</a></p>
<p class="toc1"><a href="#/Book1/9chap5#chap5">Chapter 5</a></p>
<p class="toc1"><a href="#/Book1/10chap6#chap6">Chapter 6</a></p>
<p class="toc1"><a href="#/Book1/11chap7#chap7">Chapter 7</a></p>
<p class="toc1"><a href="#/Book1/12chap8#chap8">Chapter 8</a></p>
<p class="toc1"><a href="#/Book1/13chap9#chap9">Chapter 9</a></p>
<p class="toc1"><a href="#/Book1/14chap10#chap10">Chapter 10</a></p>
<p class="toc1"><a href="#/Book1/15chap11#chap11">Chapter 11</a></p>
<p class="toc1"><a href="#/Book1/16chap12#chap12">Chapter 12</a></p>
<p class="toc1"><a href="#/Book1/17chap13#chap13">Chapter 13</a></p>
<p class="toc1"><a href="#/Book1/18chap14#chap14">Chapter 14</a></p>
<p class="toc1"><a href="#/Book1/19chap15#chap15">Chapter 15</a></p>
<p class="toc1"><a href="#/Book1/20chap16#chap16">Chapter 16</a></p>
<p class="toc1"><a href="#/Book1/21chap17#chap17">Chapter 17</a></p>
<p class="toc1"><a href="#/Book1/22chap18#chap18">Chapter 18</a></p>
<p class="toc1"><a href="#/Book1/23chap19#chap19">Chapter 19</a></p>
<p class="toc1"><a href="#/Book1/24chap20#chap20">Chapter 20</a></p>
<p class="toc1"><a href="#/Book1/25chap21#chap21">Chapter 21</a></p>
<p class="toc1"><a href="#/Book1/26chap22#chap22">Chapter 22</a></p>
<p class="toc-text-A1"><a href="#/Book2/1cover">Murder Goes Mumming</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book2/5start#chap1">Chapter 1</a></p>
<p class="toc1"><a href="#/Book2/6chap2#chap2">Chapter 2</a></p>
<p class="toc1"><a href="#/Book2/7chap3#chap3">Chapter 3</a></p>
<p class="toc1"><a href="#/Book2/8chap4#chap4">Chapter 4</a></p>
<p class="toc1"><a href="#/Book2/9chap5#chap5">Chapter 5</a></p>
<p class="toc1"><a href="#/Book2/10chap6#chap6">Chapter 6</a></p>
<p class="toc1"><a href="#/Book2/11chap7#chap7">Chapter 7</a></p>
<p class="toc1"><a href="#/Book2/12chap8#chap8">Chapter 8</a></p>
<p class="toc1"><a href="#/Book2/13chap9#chap9">Chapter 9</a></p>
<p class="toc1"><a href="#/Book2/14chap10#chap10">Chapter 10</a></p>
<p class="toc1"><a href="#/Book2/15chap11#chap11">Chapter 11</a></p>
<p class="toc1"><a href="#/Book2/16chap12#chap12">Chapter 12</a></p>
<p class="toc1"><a href="#/Book2/17chap13#chap13">Chapter 13</a></p>
<p class="toc1"><a href="#/Book2/18chap14#chap14">Chapter 14</a></p>
<p class="toc1"><a href="#/Book2/19chap15#chap15">Chapter 15</a></p>
<p class="toc1"><a href="#/Book2/20chap16#chap16">Chapter 16</a></p>
<p class="toc1"><a href="#/Book2/21chap17#chap17">Chapter 17</a></p>
<p class="toc1"><a href="#/Book2/22chap18#chap18">Chapter 18</a></p>
<p class="toc1"><a href="#/Book2/23chap19#chap19">Chapter 19</a></p>
<p class="toc1"><a href="#/Book2/24chap20#chap20">Chapter 20</a></p>
<p class="toc1"><a href="#/Book2/25chap21#chap21">Chapter 21</a></p>
<p class="toc1"><a href="#/Book2/26ack#ack">Acknowledgements</a></p>
<p class="toc-text-A1"><a href="#/Book3/1cover">A Dismal Thing To Do</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book3/7chap1#chap1">1</a></p>
<p class="toc1"><a href="#/Book3/8chap2#chap2">2</a></p>
<p class="toc1"><a href="#/Book3/9chap3#chap3">3</a></p>
<p class="toc1"><a href="#/Book3/10chap4#chap4">4</a></p>
<p class="toc1"><a href="#/Book3/11chap5#chap5">5</a></p>
<p class="toc1"><a href="#/Book3/12chap6#chap6">6</a></p>
<p class="toc1"><a href="#/Book3/13chap7#chap7">7</a></p>
<p class="toc1"><a href="#/Book3/14chap8#chap8">8</a></p>
<p class="toc1"><a href="#/Book3/15chap9#chap9">9</a></p>
<p class="toc1"><a href="#/Book3/16chap10#chap10">10</a></p>
<p class="toc1"><a href="#/Book3/17chap11#chap11">11</a></p>
<p class="toc1"><a href="#/Book3/18chap12#chap12">12</a></p>
<p class="toc1"><a href="#/Book3/19chap13#chap13">13</a></p>
<p class="toc1"><a href="#/Book3/20chap14#chap14">14</a></p>
<p class="toc1"><a href="#/Book3/21chap15#chap15">15</a></p>
<p class="toc1"><a href="#/Book3/22chap16#chap16">16</a></p>
<p class="toc1"><a href="#/Book3/23chap17#chap17">17</a></p>
<p class="toc1"><a href="#/Book3/24chap18#chap18">18</a></p>
<p class="toc1"><a href="#/Book3/25chap19#chap19">19</a></p>
<p class="toc1"><a href="#/Book3/26chap20#chap20">20</a></p>
<p class="toc1"><a href="#/Book3/27chap21#chap21">21</a></p>
<p class="toc1"><a href="#/Book3/28chap22#chap22">22</a></p>
<p class="toc1"><a href="#/Book3/29chap23#chap23">23</a></p>
<p class="toc-text-A1"><span href="#/Book1/preview1" title="Link target outside of Sample">Preview: Trouble in the Brasses</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?1ba7ed76